import type { TourStep } from '../types';
export const designerThemeNewSteps: TourStep[] = [
  { target: '[data-tour="designer-theme-claim"]', title: 'Взять задание', content: 'Подтвердите, что готовы взять это задание в работу.' },
  { target: '[data-tour="designer-theme-task"]', title: 'Требования задания', content: 'Изучите описание, сроки и требования до начала работы.' },
  { target: '[data-tour="designer-theme-plan"]', title: 'План макетов', content: 'Проверьте необходимое количество и типы макетов.' },
];
